import {request_async} from "@/utils/requestAsync";
import {API_URL_EXP_ADMIN} from "@/model/ConfigModel";

// 获取配置列表
export async function getLoginConfig(params) {
  return request_async(API_URL_EXP_ADMIN + `/admin/loginconfig/list`, "get", params);
}
